import React, { useEffect, useState } from 'react';
import Nav from '@/components/Nav';
import Footer from '@/components/Footer';
import StickyBottomMarquee, { STICKY_MARQUEE_SPACER_CLASS } from '@/components/StickyBottomMarquee';
import { api, fileUrl } from '@/lib/api';
import { MotionProvider } from '@/lib/motion';
import MaintenancePage from '@/pages/MaintenancePage';

export default function ComingSoon({ title, routeKey }) {
  const [data, setData] = useState({});
  const [stub, setStub] = useState(null);

  useEffect(() => {
    api.get('/public/home').then((r) => {
      const settings = r.data?.settings || {};
      setData(settings);
      const routes = r.data?.stub_routes || {};
      setStub(routes[routeKey] || {});
    }).catch(() => { setStub({}); });
  }, [routeKey]);

  const maintenance = data.maintenance || {};
  if (maintenance.enabled) {
    return <MaintenancePage maintenance={maintenance} />;
  }

  const motion = data.motion || {};
  const nav = data.nav || {};
  const footer = data.footer || {};
  const routeTitle = (stub && stub.title) || title || 'Coming Soon';
  const body = (stub && stub.body) || 'Coming Soon.';
  const backLabel = (stub && stub.back_label) || 'Back to Home';
  const image = stub && stub.image ? fileUrl(stub.image) : '';

  return (
    <MotionProvider motion={motion}>
      <div className={`bg-bg-canvas min-h-screen flex flex-col ${STICKY_MARQUEE_SPACER_CLASS}`}>
        <Nav nav={nav} motion={motion} />
        <main className="flex-1 flex items-center justify-center container-x section-pad" data-testid={`stub-${routeKey}`}>
          <div className="text-center max-w-2xl">
            <p className="eyebrow mb-4">SEICON III</p>
            <h1 className="font-display font-bold text-ink-primary uppercase leading-[0.95] text-[40px] md:text-[64px] lg:text-[72px] tracking-tightish" data-testid="stub-title">
              {routeTitle}
            </h1>
            {image && (
              <div className="mt-8 mx-auto max-w-xl rounded-md overflow-hidden border border-border-line" style={{ aspectRatio: '16/9' }}>
                <img src={image} alt={routeTitle} className="w-full h-full object-cover" data-testid="stub-image" />
              </div>
            )}
            <p className="mt-6 font-body text-ink-muted text-base md:text-lg whitespace-pre-line" data-testid="stub-body">{body}</p>
            <a href="/" className="btn-secondary mt-10 inline-flex" data-testid="back-home">&larr; {backLabel}</a>
          </div>
        </main>
        <Footer footer={footer} motion={motion} presentingSponsor={data.presenting_sponsor || null} />
        <StickyBottomMarquee bottomMarquee={data.bottom_marquee} />
      </div>
    </MotionProvider>
  );
}
